import { render, staticRenderFns } from "./capacity.vue?vue&type=template&id=bb8e9a58&scoped=true&"
import script from "./capacity.vue?vue&type=script&lang=js&"
export * from "./capacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8e9a58",
  null
  
)

export default component.exports